// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25tN6","content":"styles_content__1iUiv"};